<template>
  <Modal>
    <Modal.Body>
      <UploadPrivacyBody v-model="isPrivate" />
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        class="mt-5 w-full"
        :loading="loading"
        @click="handleContinue"
      >
        Continue
      </Button>
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import UploadPrivacyBody from './UploadPrivacyBody.vue'
import { useUploadPrivacy } from './useUploadPrivacy'
import { useDevice } from '@/shared/composables/useDevice'

const { close, triggerEvent } = useModal()
const { isMobile } = useDevice()
const { isPrivate, loading, persist } = useUploadPrivacy()

const handleContinue = async () => {
  await persist()
  triggerEvent('success')
  close()
}
</script>
